import { ActionState } from 'services/EpdClient';
import styled, { css } from 'styled-components';
import { ButtonSmall } from 'styles/Styles.styled';

export const MaterialGrid = styled.div`
  display: grid;
  grid-template-columns: 6fr 3fr 1fr;
  grid-template-rows: 3;
  grid-column-gap: 1rem;
  grid-row-gap: 0.5rem;
  width: 100%;
`;

export const FixedRow = styled.div<{ state?: ActionState }>`
  display: ${(props) => (props?.state === ActionState.Hidden ? 'none' : 'flex')};
  padding: 0.5rem 0;
  margin-top: 2rem;
  flex-wrap: wrap;
  ${(props) =>
    props.state === ActionState.Disabled &&
    css`
      label {
        color: gray;
      }
    `}

  ${(props) => props.theme.media.tablet} {
    flex-wrap: nowrap;
    margin-top: 0;
  }
`;

export const Column = styled.div`
  align-self: center;
  width: 100%;
`;

export const ReferenceColumn = styled(Column)`
  grid-column-start: 1;
  grid-column-end: 3;
`;

export const MaterialColumn1 = styled(Column)`
  grid-column-start: 1;
  grid-column-end: 2;
`;

export const MaterialColumn2 = styled(Column)`
  grid-column-start: 2;
  grid-column-end: 3;
`;

export const MaterialColumn3 = styled(Column)`
  justify-self: end;
  grid-column-start: 3;
  grid-column-end: 4;
`;

export const Box = styled.div`
  width: 100%;
  padding: 1rem;
  border-left: solid 3px green;
  margin: 0.5rem 0;
  background-color: #f3f3f3;
`;

export const RemoveButton = styled(ButtonSmall)`
  padding: 0.5rem;
  margin: 0.5rem 0;
  font-size: 0.8rem;
  background: rgb(105, 105, 105);
  :hover {
    background: rgb(128, 128, 128);
  }
`;

export const AddButton = styled(ButtonSmall)`
  padding: 0.5rem;
  margin: 0 0 0 0.8rem;
  font-size: 0.8rem;
`;

export const ArrowImage = styled.img`
  width: 1rem;
  height: 0.7rem;
  align-self: flex-start;
  margin-top: 6px;
`;

export const ArrowUpBox = styled.div`
  flex-grow: 1;
  width: 450px;
  margin-right: 1rem;
  white-space: wrap;
`;

export const ArrowDownBox = styled(ArrowUpBox)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SelectStyle = {
  control: (styles: any) => ({
    ...styles,
    borderRadius: 0,
    borderColor: 'gray',
    color: 'black',
    fontSize: '14px',
    minHeight: '49px',
    width: '100%',
  }),
  singleValue: (styles: any, state: any) => ({
    ...styles,
    color: state.isDisabled ? '#545454' : 'black',
  }),
  multiValueLabel: (styles: any) => ({
    ...styles,
    fontSize: '100%',
  }),
};

export const UploadButton = styled.div`
  position: relative;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;

  & u {
    cursor: pointer;
  }

  input[type='file'] {
    font-size: 100px;
    position: absolute;
    top: 0;
    right: 0;
    text-align: right;
    opacity: 0;
    cursor: pointer;
    display: block;
  }
`;
